import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { textBlock } from '@/uiPrimitives/typography/text';

export const textTag = (props?: {
	box?: Parameters<typeof box>[0];
	textBlock?: Parameters<typeof textBlock>[0];
}) =>
	classes(
		box({
			borderRadius: '2px',
			borderWidth: '1px',
			borderStyle: 'solid',
			borderColor: 'positiveMuted',
			paddingInline: '-1 | small',
			paddingBlock: '-2 | smaller',
			inlineSize: 'fit-content',
			...props?.box,
		}),
		textBlock({
			color: 'positiveMuted:noHover',
			capSize: '-1 | small',
			textDecorationLine: 'none',
			...props?.textBlock,
		}),
	);
